import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  /** Pushes a custom event into the GTM dataLayer so it can be tracked in Google Analytics. */
  public trackEvent(event: string, params: Record<string, unknown> = {}): void {
    window.dataLayer = window.dataLayer ?? [];
    window.dataLayer.push({ event, ...params });
  }
}
